var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-modal',_vm._g(_vm._b({ref:"modal",attrs:{"modal-id":"artifact-delete-modal","size":"sm","title":_vm.$options.i18n.title(_vm.artifactName),"action-primary":_vm.actionPrimary,"action-cancel":_vm.$options.actionCancel}},'gl-modal',_vm.$attrs,false),_vm.$listeners),[_vm._v("\n  "+_vm._s(_vm.$options.i18n.body)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }